<template>
  <v-row class="footer">
    <div class="container">
      <div class="disclaimer-text">
        {{ $t("lang.footer.disclaimer") }}
      </div>

      <div lang="en" class="col-sm-6 col-xs-12 left left-sm">
        {{ $t("lang.footer.copyright") }}
      </div>
      <div lang="en" class="col-sm-6 col-xs-12 powered-text right right-sm">
        <ul class="footer-links clearfix" >
          <li>
            <a
                @click.stop="menuClicked('terms-of-use')"
                lang="en"
                >
              {{ $t("lang.footer.termsOfUse") }}</a
            >
          </li>
          <li>
            <a
                @click.stop="menuClicked('privacy-policy')"
                lang="en"
                target="_blank"
            >{{ $t("lang.footer.privacyPolicy") }}
            </a>
          </li>
          <li class="hide-element-xs">{{ $t("lang.footer.poweredByMarshDigital") }}</li>
        </ul>
      </div>
      <ul class="footer-links clearfix show-element-sm" >
        <li>{{ $t("lang.footer.poweredByMarshDigital") }}</li>
      </ul>
    </div>
  </v-row>
</template>

<script>

export default {
  name: "Footer",
  data() {
    return {
      privacyLink: "assets/pdf/" + this.$store.state.country + +"/Privacy Policy.pdf",
      termsLink: "assets/pdf/" + this.$store.state.country + "/Website Terms and Conditions of Use.pdf",
      personalInfoLink: "assets/pdf/" + this.$store.state.country + +"/Privacy Policy.pdf",
    }
  },
  methods: {
    generateURL: function () {
      if (location.hostname === "yachtcover.map.marsh.com") {
        this.$store.state.isProdEnv = true;
      }
      this.fileName = '.pdf';
      this.privacyLink = "assets/pdf/" + this.$store.state.country + "/Privacy Policy" + this.fileName;
      this.termsLink = "assets/pdf/" + this.$store.state.country + "/Website Terms and Conditions of Use" + this.fileName;
    },
    menuClicked: function (p) {
      switch (p) {
        case 'PICS':
          this.$store.state.formPageNumber = -1;
          return;
        case 'privacy-policy':
          this.$store.state.formPageNumber = -2;
          return;
        case 'terms-of-use':
          this.$store.state.formPageNumber = -3;
          return;
        default:
          this.$store.state.formPageNumber = 0;
          return;
      }

    }
  },
  mounted: function () {
    this.generateURL();
  },
};
</script>
